import React, { useState } from 'react';

/**
 * Reliable CSS-transform marquee (works on mobile where scrollLeft rounding fails).
 * Renders items twice and animates translateX(-50%) for a seamless loop.
 * Pauses on hover / touch.
 */
export default function Marquee({
  items,
  renderItem,
  itemWidth,
  gap = 16,
  durationSec = 40,
  className = '',
}) {
  const [paused, setPaused] = useState(false);
  const loop = [...items, ...items];

  return (
    <div
      className={`overflow-hidden ${className}`}
      onPointerEnter={() => setPaused(true)}
      onPointerLeave={() => setPaused(false)}
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => setPaused(false)}
    >
      <div
        className="marquee-track items-stretch"
        style={{ animationDuration: `${durationSec}s`, animationPlayState: paused ? 'paused' : 'running' }}
      >
        {loop.map((it, i) => (
          <div key={i} className="shrink-0 flex" style={{ width: itemWidth, marginRight: gap }}>
            {renderItem(it, i % items.length)}
          </div>
        ))}
      </div>
    </div>
  );
}
